<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div
        class="button-back pb-3"
        [routerLink]="['/remote-command/connect-disconnect']"
      >
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">
        {{ "CONNDISCONNSETUP_TITE" | translate }}
      </h2>
      <p class="col subtitle">{{ "CONN&DISCONN_SUBTITLE" | translate }}</p>
    </div>
  </div>

  <form #crudform="ngForm" (ngSubmit)="onSubmit()">
    <div class="form-item">
      <label class="form-label" for="meterNo">{{
        "DEVICESETUP_METERNO" | translate
      }}</label>
      <div class="form-input">
        <input
          id="meterNo"
          [(ngModel)]="data.meterNo"
          #meterNo="ngModel"
          name="meterNo"
          type="text"
          pattern="^[0-9]+$"
          required
        />
        @if (crudform.submitted && meterNo.invalid) {
          <div class="validation-error">
            {{ "DEVICESETUP_METERNO" | translate
            }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
        }
        @if (!data.meterNo || data.meterNo.trim() === "") {
          <div class="validation-instruction">
            {{ "DEVICESETUP_METERNODESC" | translate }}
          </div>
        } @else if (meterNo.invalid && meterNo.errors?.["pattern"]) {
          <div class="validation-error">
            {{ "METERNUMBER_ERROR" | translate }}
          </div>
        }
      </div>
    </div>

    <div class="form-item">
      <label class="form-label">{{
        "CONNDISCONNSETUP_ACTION" | translate
      }}</label>
      <div class="custom-div">
        <div class="radio-div custom-radio-div">
          <div class="element" *ngFor="let item of actionDictionary">
            <span
              class="radiobox"
              (click)="data.setConnected = item === 'Connect'"
              [ngClass]="{
                selected: data.setConnected === (item === 'Connect'),
              }"
            >
              {{ item }}
              <input
                type="radio"
                name="actionGroup"
                [(ngModel)]="data.setConnected"
                [value]="item === 'Connect'"
                required
              />
              <label for="{{ item }}"></label>
            </span>
          </div>
        </div>
        @if (data.setConnected == null) {
          <div class="validation-instruction">
            {{ "CONNDISCONNSETUP_ACTIONDESC" | translate }}.
          </div>
        }
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="reason">{{
        "CONNDISCONNSETUP_REASON" | translate
      }}</label>
      <div class="form-input">
        <textarea
          id="reason"
          [(ngModel)]="data.reason"
          #reason="ngModel"
          name="reason"
          type="text"
          rows="4"
          required
        ></textarea>
        @if (crudform.submitted && reason.invalid) {
          <div class="second-subitem" class="validation-error">
            {{ "REASON" | translate }}
            {{ "DEVICESETUP_ISREQUIRED" | translate }}
          </div>
        } @else if (!reason.valid) {
          <div class="second-subitem" class="validation-instruction">
            {{ "CONNDISCONNSETUP_REASONDESC" | translate }}
          </div>
        }
      </div>
    </div>

    <div class="horizontal-line"></div>

    <div class="form-item-button">
      <button class="button-submit" [disabled]="crudform.invalid" type="submit">
        {{ "CONTINUE" | translate }}
      </button>
    </div>
  </form>
</div>
